import css, { SystemStyleObject, get } from '@styled-system/css'
import { compose } from '@styled-system/core'
import { SystemUiTheme } from './system-ui'

export type SxProps = {
  sx?: SystemStyleObject
  theme?: SystemUiTheme
  /** a string indiciating which variant of the componet to use */
  variant?: string
  /** the key of the variants section in the system theme */
  tx?: string
}

const sx = ({ sx, theme, ...rest }: SxProps) => {
  if (!sx) {
    return undefined
  }
  return css(sx)(theme)
}

const variantProp = ({ theme, variant, tx = 'variants' }: SxProps) =>
  css(get(theme, `${tx}.${variant}`, get(theme, variant)))(theme)

export default [sx, variantProp]
